<ng-container *ngrxLet="commercialStore.invitationsToSend$ as invitationsToSend">
  <mat-card>
    <mat-card-title>
      <div class="flex flex-row justify-between items-center">
        <h3 class="title">
          {{ '+INSTALLATIONS.INSTALLATION.PARTNER_ACCESS_MODAL.TITLE' | translate }}
        </h3>
        <mat-icon
          color="primary"
          gtm="onCancelDialog"
          gtmCategory="partnerAccessShareDeviceModal"
          (click)="onCancel()"
          >close</mat-icon
        >
      </div>
    </mat-card-title>
    <mat-card-content>
      <form [formGroup]="formGroup">
        <p class="content-title">
          {{ '+INSTALLATIONS.PARTNER_ACCESS.SETTINGS_OVERLAY.ADD_NEW_PARTICIPANT' | translate }}
        </p>

        <p class="content-description">
          {{ 'INSTALLATIONS.INSTALLATION.PARTNER_ACCESS_MODAL.DESCRIPTION' | translate }}
        </p>
        <mat-radio-group
          formControlName="accessLevel"
          class="flex flex-row items-center gap-[24px]"
        >
          <mat-radio-button
            gtm="onChange"
            gtmAction="Participant type"
            gtmCategory="partnerAccessShareDeviceModal"
            [value]="InvitationAccessLevel.Partner"
          >
            {{ 'INSTALLATIONS.INSTALLATION.PARTNER_ACCESS_MODAL.COMPANY' | translate }}
          </mat-radio-button>
          <div class="flex flex-row items-center gap-[4px]">
            <mat-radio-button
              gtm="onChange"
              gtmAction="Participant type"
              gtmCategory="partnerAccessShareDeviceModal"
              [value]="InvitationAccessLevel.Consumer"
              [disabled]="commercialStore.isCustomerInvitationPresent$ | async"
            >
              {{ 'INSTALLATIONS.INSTALLATION.PARTNER_ACCESS_MODAL.END_CUSTOMER' | translate }}
            </mat-radio-button>
            <mat-icon
              data-at-customer-radio-button
              matTooltipClass="data-at-customer-radio-button"
              inline="true"
              [matTooltip]="
                'INSTALLATIONS.INSTALLATION.PARTNER_ACCESS_MODAL.CONSUMER_EMAIL_ERROR_ALREADY_INVITED'
                  | translate
              "
              *ngIf="commercialStore.isCustomerInvitationPresent$ | async"
              class="mt-[2px]"
              >info_outline</mat-icon
            >
          </div>
        </mat-radio-group>
        <mat-form-field mat-input-height-large-label class="email-input">
          <mat-label>{{
            'INSTALLATIONS.INSTALLATION.PARTNER_ACCESS_MODAL.EMAIL_ADDRESS' | translate
          }}</mat-label>
          <input matInput formControlName="inviteeEmail" fieldTextContentTooltip />
          <mat-error *ngIf="formGroup.controls.inviteeEmail?.hasError('required')">{{
            'INSTALLATIONS.INSTALLATION.PARTNER_ACCESS_MODAL.EMAIL_ERROR_REQUIRED' | translate
          }}</mat-error>
          <mat-error *ngIf="formGroup.controls.inviteeEmail?.hasError('pattern')">{{
            'INSTALLATIONS.INSTALLATION.PARTNER_ACCESS_MODAL.EMAIL_ERROR_PATTERN' | translate
          }}</mat-error>
          <mat-error *ngIf="formGroup.controls.inviteeEmail?.hasError('emailAlreadyInvited')">{{
            'INSTALLATIONS.INSTALLATION.PARTNER_ACCESS_MODAL.EMAIL_ERROR_ALREADY_INVITED'
              | translate
          }}</mat-error>
          <mat-error *ngIf="formGroup.controls.inviteeEmail?.hasError('emailAlreadyInForm')">{{
            'INSTALLATIONS.INSTALLATION.PARTNER_ACCESS_MODAL.EMAIL_ERROR_ALREADY_IN_FORM'
              | translate
          }}</mat-error>
        </mat-form-field>
        <button
          data-at-partner-access-share-device-modal-add-participant
          type="submit"
          mat-stroked-button
          [disabled]="formGroup.invalid"
          color="primary"
          gtm="onClick"
          gtmCategory="partnerAccessShareDeviceModal"
          (click)="addParticipant()"
        >
          {{
            '+INSTALLATIONS.PARTNER_ACCESS.SETTINGS_OVERLAY.ADD_NEW_PARTICIPANT_BUTTON' | translate
          }}
        </button>
      </form>
      <div class="divider !hidden lt-md:!block"></div>
      <div *ngIf="invitationsToSend.length > 0" class="invited-participants">
        <p class="content-title">
          {{ 'INSTALLATIONS.INSTALLATION.PARTNER_ACCESS_MODAL.INVITED_PARTICIPANTS' | translate }}
        </p>
        <div
          class="invited-participants__list-of-new-participants flex flex-col justify-start items-stretch"
        >
          <ng-container *ngFor="let invitation of invitationsToSend; index as i">
            <div class="flex flex-row justify-between items-center lt-md:items-start">
              <!-- Desktop -->
              <div
                class="desktop-row lt-md:!hidden flex flex-row justify-between items-center flex-auto"
              >
                <div class="flex flex-row gap-[8px] justify-start items-center flex-auto">
                  <p class="invited-participants__email">{{ invitation.inviteeEmail }}</p>
                  <app-pill *ngIf="invitation.accessLevel" [type]="pillType.bright">
                    {{ getAccessLevelTranslation(invitation.accessLevel) | translate }}</app-pill
                  >
                  <button
                    *ngIf="invitation.responseStatus === ResponseStatus.Error"
                    class="retry-btn"
                    data-at-partner-access-share-device-modal-retry-sending-invitation
                    mat-raised-button
                    color="primary"
                    gtm="onSave"
                    gtmAction="Note"
                    gtmCategory="partnerAccessShareDeviceModal"
                    (click)="sendSpecificInvitation(i)"
                  >
                    {{ 'GENERAL.BUTTON.TRY_AGAIN' | translate }}
                  </button>
                </div>
                <ng-container
                  *ngIf="invitation.responseStatus | partnerAccessSharePillPipe as responseStatus"
                >
                  <app-pill [type]="responseStatus.type"> {{ responseStatus.text }}</app-pill>
                </ng-container>
              </div>

              <!-- Mobile -->
              <div class="!hidden flex-col lt-md:!flex gap-[4px] flex-auto">
                <p class="invited-participants__email">{{ invitation.inviteeEmail }}</p>
                <div class="flex flex-row gap-[4px] justify-start items-center">
                  <app-pill [type]="pillType.bright">
                    {{ getAccessLevelTranslation(invitation.accessLevel) | translate }}
                  </app-pill>
                  <ng-container
                    *ngIf="invitation.responseStatus | partnerAccessSharePillPipe as responseStatus"
                  >
                    <app-pill [type]="responseStatus.type"> {{ responseStatus.text }}</app-pill>
                  </ng-container>
                </div>
                <button
                  *ngIf="invitation.responseStatus === ResponseStatus.Error"
                  class="retry-btn-mobile"
                  data-at-partner-access-share-device-modal-retry-sending-invitation
                  mat-raised-button
                  color="primary"
                  gtm="onSave"
                  gtmAction="Note"
                  gtmCategory="partnerAccessShareDeviceModal"
                  (click)="sendSpecificInvitation(i)"
                >
                  {{ '+INSTALLATIONS.PARTNER_ACCESS.SETTINGS_OVERLAY.SEND_INVITATION' | translate }}
                </button>
              </div>
              <mat-icon (click)="removeParticipant(i)">close</mat-icon>
            </div>
            <div *ngIf="i < invitationsToSend.length - 1" class="divider"></div>
          </ng-container>
        </div>
      </div>
    </mat-card-content>
    <mat-card-actions
      class="!flex flex-row lt-md:flex-col-reverse lt-md:gap-[8px] justify-between items-center lt-md:justify-start"
    >
      <button
        class="cancel-btn"
        data-at-partner-access-share-device-modal-cancel-btn
        mat-button
        color="primary"
        gtm="onCancelDialog"
        gtmCategory="partnerAccessShareDeviceModal"
        (click)="onCancel()"
      >
        {{ 'GENERAL.BUTTON.CANCEL' | translate }}
      </button>
      <button
        class="send-btn"
        data-at-partner-access-share-device-modal-send-invitations
        mat-raised-button
        color="primary"
        gtm="onSave"
        gtmAction="Note"
        gtmCategory="partnerAccessShareDeviceModal"
        [disabled]="
          invitationsToSend.length === 0 || (commercialStore.isNoInstallationToSend$ | async)
        "
        (click)="sendInvitations()"
      >
        {{ '+INSTALLATIONS.PARTNER_ACCESS.SETTINGS_OVERLAY.SEND_INVITATION' | translate }}
      </button>
    </mat-card-actions>
  </mat-card>
</ng-container>
